import * as d3 from 'd3';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AnchorIcon } from '../../assets/anchor.svg';
import { formatWithCustomGigaBillion } from '../../utils/fomatNumbers';
import styles from './SummaryPanel.module.scss';


export const SummaryCardSmall = ({
  title,
  data,
  tooltipText,
  isClickable = false,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={
        isClickable
          ? `${styles.summarySmallCard} ${styles.clickable}`
          : styles.summarySmallCard
      }
      onClick={() => {
        if (isClickable) {
          onClick();
        } else {
          return;
        }
      }}
      data-tooltip-id={`summaryCardTooltip_${title}`}
      data-tooltip-content={isClickable ? t(tooltipText) : ''}
    >
      <div className={styles.summarySmallCardTitle}>{t(title)}</div>
      <div className={styles.summarySmallCardData}>
        {data === null ? t('N/A') : formatWithCustomGigaBillion(data)}
        {!isClickable && tooltipText && (
          <AnchorIcon
            className={styles.anchorIcon}
            data-tooltip-id={`summaryCardAnchorTooltip_${title}`}
            data-tooltip-content={t(tooltipText)}
          />
        )}
      </div>
      <Tooltip id={`summaryCardTooltip_${title}`} place="bottom" style={{'width': '350px'}}/>
      <Tooltip id={`summaryCardAnchorTooltip_${title}`} place="bottom" />
    </div>
  );
};
